import {cultureAgentApiHost, fetchCultureAgentAnonymousSessionLogout} from '../culture-agent/api';

/**
 * Clears the survey session by calling the culture agent anonymous-session logout endpoint.
 * Use after sign-up succeeds when the user came from the chat/survey flow.
 */
export async function logoutAnonymousSession(): Promise<void> {
  const apiHost = cultureAgentApiHost();
  if (!apiHost && process.env.NODE_ENV !== 'development') {
    console.warn(
      'logoutAnonymousSession: REACT_APP_CULTURE_AGENT_API_HOST is not set; skipping anonymous-session logout'
    );
    return;
  }

  await fetchCultureAgentAnonymousSessionLogout(apiHost);
}
